module.exports = __webpack_public_path__ + "img/cart-flatbed-empty.bb7400ab.svg";